var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mb-8 mt-10"},[_c('container',{staticClass:"flex justify-center relative"},[(_vm.showCategoryListForDesktop)?_c('category-list-desktop',{attrs:{"category-cards":_vm.categoryCards}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"lg:hidden"},[_c('box-list',{attrs:{"category-cards":_vm.categoryCards}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }